import { CircularProgress } from '@material-ui/core';
import { useSearchStatus } from '../../../../../hooks/useSearchStatus';
import styles from './style.module.css';
import noResultImg from '../../../../../assets/ic-search-not-found.svg';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { useGetFiltersList } from '../../../../../hooks/useGetFiltersList';
import { OnDemandES, PickupOnlyES, DeliveryOnlyES } from "@onro/onboarding";
import React from 'react';
import { Route } from 'react-router-dom';
import history from '../../../../../service/history';
import { useDispatch, useSelector } from 'react-redux';
import { ServicesVehicletypeAction } from '../../../../../Redux/actions/actions';
import { box_gray } from '../../../../../assets';
import IconProvider from '../../../../../design-system/lib/IconProvider';
import Typography from '../../../../../design-system/lib/Typography';
import Button from '../../../../../design-system/lib/Button';
import { clearAll_ActiveFilter } from '../../../../../Redux/actions/actionTypes';
import { SetOrderListFiltersDueTime, SetOrderListFiltersServices, SetOrderListFiltersStatus, SetOrderListFiltersVehicleTypes, SetOrderListFiltersZone, SetOrderListStatsData, SetOrderListStatsLoading } from '../../../../../Redux/actions/actionNames';


export const ListNoresult = ({ stats, showEmpty, filtersCount }) => {
    let { regexText, listNoResult, searchNoResult, loading, listLoading } = useSearchStatus()
    let { cursor, cursorSort, DateRange, selectedServices, selectedStatus, selectedVehicleType, isScheduled, changed, zones } = useGetFiltersList()

    const dispatch = useDispatch();
    const center = useSelector((state) => state.Map.center)

    const { t, i18n } = useTranslation();



    const ClearAll = React.useCallback(() => {
        dispatch(SetOrderListStatsLoading(true))
        dispatch(SetOrderListStatsData(null))
        dispatch(SetOrderListFiltersZone([]))
        dispatch(SetOrderListFiltersStatus([]))
        dispatch(SetOrderListFiltersServices([]))
        dispatch(SetOrderListFiltersDueTime({ key: "now", value: false }))
        dispatch(SetOrderListFiltersDueTime({ key: "isScheduled", value: false }))


 
        dispatch(SetOrderListFiltersVehicleTypes([]))

            const myEvent = new CustomEvent("resetFilters", { detail: null });
            document.dispatchEvent(myEvent);
    }, []);



    const hasAtleastOneStat = React.useCallback(() => {
        if (!stats) {
            return false
        }

        let has = false;
        for (const [key, value] of Object.entries(stats)) {


            if (Number(value) > 0) {
                has = true
            }
        }
        return has

    }, [stats]);



    if (showEmpty) {
        if (String(regexText).length == 0 && !hasAtleastOneStat() && !listLoading) {
            return <div style={{ width: "100%", marginTop: "32px", display: "flex", flexDirection: "row", justifyContent: "center", float: "left" }}>

                <Route path="/Ondemand" exact>
                    <OnDemandES articleTitle="How to create order?" articleLink="https://help.onro.io/en/articles/9980258-create-your-first-order" emptyStateTitle={t("Create Ondemand order")} emptyStateDescription={t("Your orders will be shown here in list")}
                        ImportButtonTitle={t("Import")} NewButtonTitle={t("new")} onImportAction={() => {
                            history.push("/BulkImport")
                        }} onNewAction={() => {
                            dispatch(ServicesVehicletypeAction(dispatch, center))
                            // dispatch(ChangeNewTravelDialoge());
                            history.push("/neworder")
                        }} />
                </Route>

                <Route path="/Pickup" exact>
                    <PickupOnlyES articleTitle="How to create order?" articleLink="https://help.onro.io/en/articles/9980258-create-your-first-order" emptyStateTitle={t("Create Pickup Only order")} emptyStateDescription={t("Your orders will be shown here in list")}
                        ImportButtonTitle={t("Import")} NewButtonTitle={t("new")} onImportAction={() => {
                            history.push("/BulkImport")
                        }} onNewAction={() => {
                            dispatch(ServicesVehicletypeAction(dispatch, center))
                            // dispatch(ChangeNewTravelDialoge());
                            history.push("/neworder")
                        }} />

                </Route>

                <Route path="/Delivery" exact>
                    <DeliveryOnlyES articleTitle="How to create order?" articleLink="https://help.onro.io/en/articles/9980258-create-your-first-order" emptyStateTitle={t("Create Delivery Only order")} emptyStateDescription={t("Your orders will be shown here in list")}
                        ImportButtonTitle={t("Import")} NewButtonTitle={t("new")} onImportAction={() => {
                            history.push("/BulkImport")
                        }} onNewAction={() => {
                            dispatch(ServicesVehicletypeAction(dispatch, center))
                            // dispatch(ChangeNewTravelDialoge());
                            history.push("/neworder")
                        }} />

                </Route>

            </div>
        } else {
            return null
        }
    } else {
        if (!hasAtleastOneStat() && filtersCount > 0) {
            return <div className={styles.dialog}>
                <IconProvider Icon={box_gray} style={{ marginBottom: "16px" }} />
                <Typography weight='Body_Middle_Bold' text={t('No result found')} style={{ textAlign: "center", marginBottom: "4px" }} />
                <Typography weight='Body_Tiny_Regular' text={t('Please check your filters or keyword')} style={{ textAlign: "center", marginBottom: "16px" }} />
                <Button size='Medium' type='Primary' text={t('Clear All')} onClick={ClearAll} />
            </div>
        } else
            return null
    }






};




